import { EXTERNAL_API_URL } from "@/config/site";
import { useState } from "react";
import React from "react";

function AssetLogo({ id, folder, alt, size = 40, className = '', src = '' }: { id: number, folder: string, alt: string, size?: number, className?: string, src?: string }) {
    const [error, setError] = useState(false);
    return (
        <img
            src={
                error ?
                    `${EXTERNAL_API_URL}/logos/${folder}/not-found.png` :
                    (
                        src == '' ?
                            `${EXTERNAL_API_URL}/logos/${folder}/${id}.png`
                            : src
                    )
            }
            onError={() => setError(true)}
            alt={alt}
            width={size}
            height={size}
            style={{
                height: size + 'px',
                width: size + 'px',
                display: 'inline-block', filter: 'drop-shadow(1px 0 0 gray) drop-shadow(0 1px 0 gray) drop-shadow(-1px 0 0 gray) drop-shadow(0 -1px 0 gray)'
            }}
            className={className}
        />
    );
}

export default React.memo(AssetLogo);